import { http } from '@/lib/http';

// Cliente HTTP de la feature auth.
//
// La entrada con Effetá Apps no es una llamada: es una navegación de página
// entera (ver `effeta-login.ts`). El pase y el perfil los pide el session
// store (`@/lib/auth-refresh`).

// Cierra la sesión del PIM (no la de Effetá Apps: Effetá no ofrece cómo).
// Va con credenciales (la cookie de sesión del API) y sin Authorization: el
// back no la necesita y así un pase vencido no dispara una renovación. Responde
// 200 siempre, haya sesión o no.
export async function logout(): Promise<void> {
  await http.post('/auth/logout', undefined, { skipAuth: true, parseResponse: 'none' });
}

// Tour state — persistencia por user en backend ----------------------------

// Marca una key de ruta como vista. Idempotente y atómico del lado del
// back (jsonb_set), así que múltiples pestañas marcando distintas keys
// no se pisan. `key` debe ser un pattern de ruta (`/products/:sku`),
// no un pathname real (`/products/SKU-001`).
export async function markTourSeen(key: string): Promise<void> {
  await http.patch('/auth/me/tour-state/seen', { key }, { parseResponse: 'none' });
}

// Setea preferencias globales. Hoy solo `neverShow` — si true, el front
// no debe disparar ningún tour aunque falten keys en `seen`.
export async function setTourPreferences(prefs: { neverShow: boolean }): Promise<void> {
  await http.patch('/auth/me/tour-state/preferences', prefs, {
    parseResponse: 'none',
  });
}

// Vacía el objeto `seen` (no toca `neverShow`). Usado por el botón
// "Volver a ver todos los tours" del menú del usuario.
export async function resetTourSeen(): Promise<void> {
  await http.delete('/auth/me/tour-state/seen', { parseResponse: 'none' });
}
